import { apiClient } from "./client";
import type { ApiResponse } from "./common";

// ============================================================================
// V3 Subscription Types (matching backend schema)
// ============================================================================

export interface DtoCurrencyOptionsV3 {
  unitAmount?: number;
  unitAmountDecimal?: string;
}

export interface DtoProductV3 {
  id: string;
  name: string;
  defaultPrice?: string;
  description?: string;
  images?: string[];
  metadata?: Record<string, any>;
}

export interface DtoRecurringV3 {
  aggregateUsage?: string;
  interval?: "month" | "year" | "week" | "day";
  intervalCount?: number;
}

export interface DtoPriceV3 {
  id: string;
  product: string | DtoProductV3;
  currency?: string;
  currencyOptions?: Record<string, DtoCurrencyOptionsV3>;
  lookupKey?: string;
  recurring?: DtoRecurringV3;
  unitAmount?: number;
  unitAmountDecimal?: string;
  allowTrial: boolean;
  tierName: "plus" | "premium" | "ultra";
  tierNumber?: number;
}

export interface DtoPaypalPlan {
  planId?: string;
  name?: string;
  description?: string;
  lookupKey?: string;
  price?: number;
  currencyCode?: string;
  interval?: string;
  intervalCount?: number;
  tierName?: "plus" | "premium" | "ultra";
  tierNumber?: number;
  allowTrial?: boolean;
}

export interface DtoStripeSubscriptionConfig {
  prices: DtoPriceV3[];
  lookupKeyPath: string[];
  upgradingOfferLookupKey?: string;
  trialDays: number;
}

export interface DtoPaypalSubscriptionConfig {
  plans?: DtoPaypalPlan[];
  lookupKeyPath?: string[];
  trialDays?: number;
}

export interface SubscriptionConfigV3Response {
  stripeConfig: DtoStripeSubscriptionConfig;
  paypalConfig: DtoPaypalSubscriptionConfig;
}

// ============================================================================
// API Response Wrapper
// ============================================================================

export type SubscriptionConfigApiResponse = ApiResponse<SubscriptionConfigV3Response>;

// ============================================================================
// Subscription API
// ============================================================================

export const subscriptionApi = {
  async getSubscriptionConfig(): Promise<SubscriptionConfigV3Response> {
    const response = await apiClient.makeAuthenticatedRequest<SubscriptionConfigV3Response>(
      "/payment/v3/subscription_config",
      {
        method: "POST",
        params: {},
      }
    );

    return response;
  },
};
